/** Акцент и кнопки скачивания PDF в превью отчётов (единый вид тулбаров). */
export const REPORT_ACCENT = 'var(--ds-accent)'

export const reportPdfButtonStyle = {
  background: REPORT_ACCENT,
  color: 'var(--ds-accent-text)',
}
